<template>
  <div class="module" :id="moduleData.itemCode" style="padding-bottom: 20px;">
    <div class="module-label">
      {{moduleData.itemName}}
    </div>
    <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-position="top">
      <div style="padding: 0 25px 0 19px;">
        <el-form-item label="请选择运输方式" class="is-required transport-type" prop="transportMode">
          <el-checkbox-group v-model="form.transportMode" :disabled="disabledAll">
            <el-checkbox v-for="item in chooseObj.attrs[0].enums" :key="item.enumCode" :label="item.enumCode">{{item.enumName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <div class="area-list">
      <template v-for="item in areaList">
        <div class="area-item" v-if="form.transportMode.includes(item.areaCode)" :key="item.areaCode">
          <div class="area-title">{{item.areaName}}</div>
          <TFSBasicForm
            :attrs="item.attrs"
            v-bind.sync="commonProps"
            :currentData="formInfo.formAttrList"
            :ref="item.areaCode"></TFSBasicForm>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import TFSBasicForm from "src/components/application/components/TFSBasicForm.vue";
export default {
  name: "TFSTransport",
  mixins: [applyMixins],
  components: {TFSBasicForm},
  data() {
    return {
      form: {
        transportMode: []
      },
      areaList: [],
      chooseObj: {
        attrs: [
          {
            enums: []
          }
        ]
      },
    }
  },
  computed: {
    rules() {
      return {
        transportMode: [this.required],
      }
    },
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const areaCodeArr = this.moduleData.children.map(v => v.itemCode)
        const list = []
        let form = {
          transportMode: []
        }
        val.forEach(v => {
          if (areaCodeArr.includes(v.areaCode)) {
            list.push(v)
          }
          if (v.areaCode === 'TFSTransport') {
            this.chooseObj = v
          }
        })
        this.areaList = list
        if (!this.isCountryChange && this.formInfo.formAttrList && this.formInfo.formAttrList.length) {
          this.formInfo.formAttrList.some(v => {
            if (v.attrCode === 'transportMode') {
              form.transportMode = v.attrText || []
              return true
            }
          })
        }
        this.form = form
      },
      immediate: true
    },
  },
  methods: {
    getValidate() {
      const arr = [new Promise(resolve => this.$refs.form.validate(resolve))]
      let list = []
      const listArr = [].concat(this.chooseObj, this.areaList)
      listArr.forEach((v, index) => {
        if (index !== 0 && !this.form.transportMode.includes(v.areaCode)) return
        if (index === 0) {
          v.attrs.forEach(item => {
            item.attrValue = ''
            if (item.type === 10 || item.type === 11 || item.type === 3) {
              item.attrText = this.form[item.attrCode]
              return
            }
            item.attrValue = this.form[item.attrCode]
          })
          list = list.concat(v.attrs)
        } else {
          const data = this.$refs[v.areaCode][0].getValidate()
          arr.push(data.validator)
          list = list.concat(data.list)
        }
      })
      const data = {
        formAttrList: list
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return arr
    },
  }
}
</script>

<style scoped lang="scss">
.transport-type {
  display: flex;
  ::v-deep .el-form-item__label {
    width: 133px;
    flex-shrink: 0;
    padding: 0;
    line-height: 18px;
  }
  .el-checkbox-group {
    line-height: 18px;
  }
}
.area-item {
  background: rgb(245, 245, 245);
  padding: 20px 24px 17px 19px;
  margin-bottom: 21px;
  .area-title {
    color: rgb(51, 51, 51);
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 22px;
  }
  ::v-deep .el-form-item__label {
    line-height: 18px;
  }
}
</style>